import { render } from "./AdminView75Liquidation.vue?vue&type=template&id=1b755216"
import script from "./AdminView75Liquidation.vue?vue&type=script&lang=js"
export * from "./AdminView75Liquidation.vue?vue&type=script&lang=js"

import "./AdminView75Liquidation.vue?vue&type=style&index=0&id=1b755216&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__